import { ForgotPassword } from 'components/templates';
import React from 'react';

import { LoginViewBox } from './styles';

export const ForgotPasswordView = () => {
  return (
    <LoginViewBox>
      <ForgotPassword />
    </LoginViewBox>
  );
};
